import { ImportLinkItem } from "core/types/search.types";

// Stesso tetto del backend (controllers/SearchImport.py MAX_ITEMS_PER_CALL): ogni
// chiamata scarica le anteprime dei suoi link, quindi lotti piccoli e in sequenza.
export const IMPORT_BATCH_SIZE = 25;

export const IMPORT_ACCEPT = ".xlsx,.csv,.txt";

// Lo stesso limite del backend (libs/link_import.py MAX_UPLOAD_BYTES): fermarsi qui
// evita di caricare 30 MB per sentirsi dire 413.
export const IMPORT_MAX_BYTES = 5 * 1024 * 1024;

// Solo i link nuovi partono: quelli gia' nella ricerca o ripetuti nel file si mostrano
// ma non si mandano (il backend li riconoscerebbe comunque come doppioni).
export const newImportItems = (items: ImportLinkItem[]): ImportLinkItem[] =>
  items.filter((item) => item.duplicate === null);

export const chunkItems = <T>(items: T[], size: number): T[][] => {
  const step = Math.max(1, Math.floor(size) || 1);
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += step) {
    out.push(items.slice(i, i + step));
  }
  return out;
};

// Codici di errore del backend che hanno un messaggio dedicato in importLinks.errors.
const KNOWN_ERRORS = [
  "too_large",
  "too_many_links",
  "unsupported",
  "unreadable",
  "empty",
  "no_file",
  "not_found",
  "too_complex",
  "search_running",
  "forbidden",
];

export const importErrorKey = (error: any): string => {
  const code = error?.response?.data?.code;
  return KNOWN_ERRORS.includes(code)
    ? `importLinks.errors.${code}`
    : "importLinks.errors.generic";
};
